import * as moment from 'moment';
import 'moment/locale/es';

export function formatEventDate(date: Date | string): string {
    return moment(date).locale('es').format('DD') + ' de ' + moment(date).format('MMMM');
}

export function formatEventTime(date: Date | string): string {
    return moment(date).locale('es').format('LT') + ' hs';
}
